import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "../assets/css/Pricing.css";
import { TabView, TabPanel } from 'primereact/tabview';
import { Badge } from 'primereact/badge';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Button } from "primereact/button";
import { BiCheckCircle } from "react-icons/bi";
import { useAuth } from "../context/AuthContext";
import api from "../api/axios";
import Planchangemonthly from "../components/Planchangemonthly";
import Planchangeannual from "../components/Planchangeannual";

const PlanChangePage = () => {

    const annualHeader = (
        <span className="d-flex align-items-center gap-2">
            Annual 
            {/* <Badge value="SAVE 25%" severity="danger" /> */}
        </span>
    );

    /* ---------------- UI ---------------- */

    return (
        <Container className="py-5">
            <Row className="mx-0 justify-content-center text-center">
                <h1>Pricing</h1>
                <div className="d-flex justify-content-center mb-3 mt-1">
                    <AvatarGroup>
                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/asiyajavayant.png" shape="circle" />
                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" />
                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/ionibowcher.png" shape="circle" />
                        <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png" shape="circle" />
                        <Avatar label="Trusted by 700,000+ creative teams, marketers, and designers" shape="circle" className="textBag" />
                    </AvatarGroup>
                </div>
            </Row>
            <TabView className="price-tab pb-5">
                <TabPanel header="Monthly">
                    <Planchangemonthly />
                </TabPanel>
                <TabPanel header={annualHeader}>
                    <Planchangeannual />
                </TabPanel>
            </TabView>
        </Container>
    );
};

export default PlanChangePage